"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
var constants_1 = require("./constants");
var resizeObserver = new resize_observer_polyfill_1.default(function (entries) {
    entries.forEach(function (entry) {
        try {
            var contentRect = entry.contentRect, target = entry.target;
            var onResizeContainer = new CustomEvent(constants_1.eventType, {
                detail: contentRect,
            });
            target.dispatchEvent(onResizeContainer);
        }
        catch (error) {
            console.error('error');
        }
    });
});
exports.default = resizeObserver;
//# sourceMappingURL=resizeObserver.js.map